import { useEffect } from "react";
import { RootState } from "../../../types/redux";
import BankAccountsApi from "../../../api/bankAccounts";
import { CountryType } from "../../../types/api/catalog";
import { useSelector } from "react-redux";
import { DropdownType } from "../../../types/fields";
import useErrorModal from "../../useErrorModal";

const useFetchCountryCurrencyOptions = (setCountryOptions: React.Dispatch<React.SetStateAction<DropdownType[]>>, setCountries: React.Dispatch<React.SetStateAction<CountryType[]>>) => {
  const userGuid = useSelector((state: RootState) => state.user.profile.userGuid);
  const openErrorModal = useErrorModal();

  const getCountries = async () => {
    try {
      const response = await BankAccountsApi.GetCountriesCurrencies(userGuid) as CountryType[];
      const countryOptions = response.map((country: CountryType) => { return { label: country.name, value: String(country.id) } });
      setCountryOptions(countryOptions);
      setCountries(response);
    } catch (err) {
      openErrorModal(err);
    }
  }

  useEffect(() => {
    if (userGuid) {
      getCountries();
    }
  }, [userGuid]);
}

export default useFetchCountryCurrencyOptions;